import Input, { InputWrapper, Label } from 'components/Form/Input'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'
import { WrappedComponentProps } from 'react-intl'

type Props = {
  addressLine1: string
  addressLine2: string
  city: string
  isPostalCodeValid: boolean
  postalCode: string
  setAddressLine1: (string) => void
  setAddressLine2: (string) => void
  setCity: (string) => void
  setPostalCode: (string) => void
} & WrappedComponentProps

const GeneralFields = ({
  addressLine1,
  addressLine2,
  city,
  intl,
  isPostalCodeValid,
  postalCode,
  setAddressLine1,
  setAddressLine2,
  setCity,
  setPostalCode
}: Props) => (
  <>
    <InputWrapper>
      <Label htmlFor='kyc-address'>
        <I18n data={messages.label_first_line} />
      </Label>
      <Input
        name='kyc-address1'
        onChange={(val) => setAddressLine1(val)}
        value={addressLine1}
        placeholder={intl.formatMessage(messages.placeholder_first_line)}
      />
      <Input
        name='kyc-address2'
        onChange={(val) => setAddressLine2(val)}
        value={addressLine2}
        placeholder={intl.formatMessage(messages.placeholder_second_line)}
      />
    </InputWrapper>
    <InputWrapper>
      <Label htmlFor='kyc-zip'>
        <I18n data={messages.label_postcode} />
      </Label>
      <Input
        hasError={!isPostalCodeValid && postalCode !== ''}
        name='kyc-zip'
        onChange={(val) => setPostalCode(val)}
        value={postalCode}
      />
    </InputWrapper>
    <InputWrapper>
      <Label htmlFor='kyc-city'>
        <I18n data={messages.label_city} />
      </Label>
      <Input name='kyc-city' onChange={(val) => setCity(val)} value={city} />
    </InputWrapper>
  </>
)

export default GeneralFields
